module.exports = __webpack_public_path__ + "static/media/ic_local_printshop_24px.c331cb33.svg";